import React, { Component } from 'react';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import view, { borders, validation } from '../../Enums';
import { NavLink } from 'react-router-dom';
import { Event } from '../LandingPageNew/Tracking/Track';

class FormSeller2 extends Component {
  state = {
    first: borders.NORMAL_BORDER,
    second: borders.NORMAL_BORDER,
    third: borders.NORMAL_BORDER,
    forth: borders.NORMAL_BORDER,
    fifth: borders.NORMAL_BORDER
  };

  componentDidMount() {
    Event('Seller form', 'seller form viewed', '', '');
  }

  render() {
    let gc = this.props.getContent;
    let guc = this.props.getUniversalContent;
    let gs = this.props.getStyle;
    let gi = this.props.getImage;

    return (
      <React.Fragment>
        {this.props.globalData.form_translations && (
          <div
            style={{
              height: this.props.screenheight - 80 + 'px',
              overflowY: 'scroll'
            }}
          >
            <div>
              {this.props.viewMode == view.DESKTOP && (
                <NavLink
                  exact
                  to={
                    this.props.globalData.locale
                      ? '/' + this.props.globalData.locale
                      : '/'
                  }
                  style={{ textDecoration: 'none', color: '#ffffff' }}
                >
                  <img src={gi('OYO_WHITE')} style={gs('form1_icon')} />
                </NavLink>
              )}
              <div style={gs('text_div_form_one')}>
                <span style={gs('form1_step_one_text')}>{gc('step_2')}</span>
                <span style={gs('form1_step_two_text')}>
                  {' ' + gc('of_2')}
                </span>

                <div style={gs('lets_start_contact')}>{gc('tell_us_more')}</div>
                <div style={gs('all_communications_with')}>
                  {gc('all_communications_with')}
                </div>
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formSeller_hotelName')}
                </div>
                <input
                  style={{
                    ...gs('form1_input'),
                    border: this.props.sellerBorderHotelValidated
                      ? this.state.first
                      : borders.RED_BORDER
                  }}
                  className="hideArrow mobile"
                  placeholder={gc('formSeller_hotelName_placeholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData.formData
                      ? this.props.globalData.formData.hotel_name
                      : ''
                  }
                  onChange={e => {
                    Event('seller form', 'property name entered', '', '');
                    this.props.validate(
                      e.target.value,
                      validation.SELLER_HOTEL_NAME
                    );
                    this.props.globalActions.dataUpdate(
                      'hotel_name',
                      e.target.value
                    );
                  }}
                  onFocus={event => {
                    this.setState({
                      first: borders.ACTIVE_BORDER
                    });
                  }}
                  onBlur={event => {
                    this.setState({
                      first: borders.NORMAL_BORDER
                    });
                  }}
                />
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formSeller_address')}
                </div>
                <input
                  style={{
                    ...gs('form1_input'),
                    border: this.props.sellerBorderAddress
                      ? this.state.second
                      : borders.RED_BORDER
                  }}
                  className="hideArrow mobile"
                  placeholder={gc('formSeller_address_placeholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData.formData
                      ? this.props.globalData.formData.hotel_address
                      : ''
                  }
                  onChange={e => {
                    Event('seller form', 'Address entered', '', '');
                    this.props.validate(
                      e.target.value,
                      validation.SELLER_HOTEL_ADDRESS
                    );
                    this.props.globalActions.dataUpdate(
                      'hotel_address',
                      e.target.value
                    );
                  }}
                  onFocus={event => {
                    this.setState({
                      second: borders.ACTIVE_BORDER
                    });
                  }}
                  onBlur={event => {
                    this.setState({
                      second: borders.NORMAL_BORDER
                    });
                  }}
                />
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formSeller_rooms')}
                </div>
                <input
                  className="hideArrow mobile"
                  style={{
                    ...gs('form1_input'),
                    border: this.props.sellerBorderNumberOfRooms
                      ? this.state.third
                      : borders.RED_BORDER
                  }}
                  placeholder={gc('formSeller_rooms_placeholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData
                      ? this.props.globalData.number_of_rooms
                      : ''
                  }
                  onChange={e => {
                    Event(
                      'seller form',
                      'property name entered',
                      'no of rooms entered',
                      ''
                    );
                    if (!isNaN(e.target.value) && e.target.value.length <= 3) {
                      this.props.validate(
                        e.target.value,
                        validation.SELLER_NUMBER_OF_ROOMS
                      );
                      this.props.globalActions.updateNumberOfRooms(
                        e.target.value
                      );
                    }
                  }}
                  onFocus={event => {
                    this.setState({
                      third: borders.ACTIVE_BORDER
                    });
                  }}
                  onBlur={event => {
                    this.setState({
                      third: borders.NORMAL_BORDER
                    });
                  }}
                />
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formSeller_revenue')}
                </div>
                <input
                  className="hideArrow mobile"
                  style={{ ...gs('form1_input'), border: this.state.forth }}
                  placeholder={gc('formSeller_revenuePlaceholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData.formData
                      ? this.props.globalData.formData.last_year_revenue
                      : ''
                  }
                  onChange={e => {
                    Event('seller form', 'last year revenue entered', '', '');
                    this.props.globalActions.dataUpdate(
                      'last_year_revenue',
                      e.target.value
                    );
                  }}
                  onFocus={event => {
                    this.setState({
                      forth: borders.ACTIVE_BORDER
                    });
                  }}
                  onBlur={event => {
                    this.setState({
                      forth: borders.NORMAL_BORDER
                    });
                  }}
                />
              </div>

              <div style={gs('form1_input_parent')}>
                <div style={gs('input_label_form')}>
                  {gc('formSeller_profit')}
                </div>
                <input
                  className="hideArrow mobile"
                  style={{ ...gs('form1_input'), fifth: borders.NORMAL_BORDER }}
                  placeholder={gc('formSeller_revenuePlaceholder')}
                  type="text"
                  required
                  autoComplete="new-password"
                  value={
                    this.props.globalData.formData
                      ? this.props.globalData.formData.revenue_without_tax
                      : ''
                  }
                  onChange={e => {
                    Event(
                      'seller form',
                      'last year revenue without tax entered',
                      '',
                      ''
                    );
                    this.props.globalActions.dataUpdate(
                      'revenue_without_tax',
                      e.target.value
                    );
                  }}
                  onFocus={event => {
                    this.setState({
                      fifth: borders.ACTIVE_BORDER
                    });
                  }}
                  onBlur={event => {
                    this.setState({
                      fifth: borders.NORMAL_BORDER
                    });
                  }}
                />
              </div>

              <div style={gs('button_parent_form')}>
                {this.props.viewMode == view.DESKTOP && (
                  <div
                    style={gs('button_left_form')}
                    className={'hover'}
                    onClick={() => {
                      Event('seller form', 'Back button clicked', '', '');
                      this.props.backToStepOne();
                    }}
                  >
                    <span style={gs('button_left_form_text')}>
                      <img
                        style={{
                          position: 'relative',
                          top: '2px',
                          marginRight: '8px'
                        }}
                        src={gi('gray_arrow_left')}
                      />
                      {gc('back_to_step_1')}
                    </span>
                  </div>
                )}

                <div
                  onClick={this.props.validateCurrentForm}
                  style={gs('button_right_form')}
                  className={'hoverColor'}
                >
                  <span
                    className={'noselect'}
                    style={gs('button_right_form_text')}
                  >
                    {guc('next')}
                    <img
                      style={{
                        marginLeft: '8px',
                        position: 'relative',
                        top: '2px'
                      }}
                      src={gi('white_arrow_right')}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormSeller2);
